module.exports = __webpack_public_path__ + "img/karaage.22cda7d5.jpg";